export default __webpack_public_path__ + "static/media/kwikswap-rocket-falcon.21bf352c.png";